import styled, { css } from 'styled-components'

import _Link from '../../atoms/Link'
import _Icon from '../../atoms/Icon'
import { mq, sizes } from '../../../theme'

export const StickyWrapper = styled.div<{ $isSticky: boolean }>`
  ${({ $isSticky }) =>
    $isSticky &&
    css`
      position: fixed;
      bottom: 8rem;
      left: 50%;
      right: 0;
      z-index: 10;
      width: 100%;
      max-width: ${({ theme }) => (theme.sizes.scopingMedium + 40) / 10}rem;
      transform: translateX(-50%);
      display: flex;
      padding: 0 1.5rem;

      @media ${mq(sizes.desktop)} {
        bottom: 2rem;
        padding: 0 2rem;
        gap: 3rem;
      }
    `}
`

export const Container = styled.div<{ $isSticky: boolean }>`
  border-radius: 2rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  width: 100%;

  ${({ $isSticky }) =>
    $isSticky &&
    css`
      border-radius: 2rem;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      /* max-width: 84.4rem; */
      width: 100%;
    `}
`

export const RightContent = styled.div<{ $isSticky: boolean }>`
  display: none;
  @media ${mq(sizes.desktop)} {
    display: flex;
    flex-direction: column;
    width: min(calc(100% / 3), 40.8rem);
    flex-shrink: 0;

    ${({ $isSticky }) =>
      !$isSticky &&
      css`
        display: none;
      `}
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 2rem;
`

export const Title = styled.p`
  ${({ theme }) => theme.textStyles.titleH4}
  color: ${({ theme }) => theme.colors.ruby};
  margin: 0;
`

export const Icon = styled(_Icon)`
  width: 1.6rem;
  height: 1.6rem;
  color: ${({ theme }) => theme.colors.bismark};
`

export const Content = styled.div<{ $isCollapsed: boolean }>`
  max-height: ${({ $isCollapsed }) => ($isCollapsed ? '0' : '29rem')};
  overflow-y: auto;
  transition: max-height 0.3s ease-in-out;
  ${({ $isCollapsed }) =>
    !$isCollapsed &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.chablis};
    `}
`

export const List = styled.ol<{ $isChild?: boolean }>`
  margin: 0;
  padding: 0;
  list-style: none;
  display: ${({ $isChild }) => ($isChild ? 'none' : 'inherit')};

  & > li:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.colors.chablis};
  }

  & > li {
    border-top: ${({ $isChild }) => ($isChild ? `1px solid #F0E6D9` : 'none')};
  }

  @media ${mq(sizes.tablet)} {
    display: inherit;
  }
`

const h2Style = css`
  ${({ theme }) => theme.textStyles.textMediumStrong}
`

const h3Style = css`
  ${({ theme }) => theme.textStyles.textMedium}
`

export const ItemLink = styled(_Link)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;

  &:hover {
    /* background-color: ${({ theme }) => theme.colors.snow}; */
    & svg {
      visibility: visible;
    }
    & span {
      color: ${({ theme }) => theme.colors.arapawa};
    }
  }
`

export const Item = styled.li<{ $level: number }>`
  ${({ $level }) => ($level === 2 ? h2Style : h3Style)}
  /* border-top: 1px solid ${({ theme }) => theme.colors.chablis}; */
  margin: 0;

  ${ItemLink} {
    padding: ${({ $level }) =>
      $level === 2 ? '1.5rem' : '1.5rem 1.5rem 1.5rem 3rem'};
  }
`

export const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 1.6rem);
`

export const ItemCount = styled.span`
  display: flex;
  ${({ theme }) => theme.textStyles.textMediumStrong}
  color: ${({ theme }) => theme.colors.ruby} !important;
  font-weight: 700;
  margin-right: 1rem;
  width: fit-content;
  height: 100%;
`

export const ItemText = styled.span`
  color: ${({ theme }) => theme.colors.greyChateau};
  max-width: 90%;
`

export const ItemIcon = styled(_Icon)`
  width: 1.6rem;
  height: 1.6rem;
  color: ${({ theme }) => theme.colors.ruby};
  visibility: hidden;
`

export const Box = styled.div`
  position: relative;
`

export const Skeleton = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`
